import { createFileRoute, useNavigate, useRouterState } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { employeesService, EmployeeAuditLog } from '@/features/employees/services/employees.service';
import { EmployeeLogsTable } from '@/features/employees/components/EmployeeLogsTable';
import { EmployeeLogDetailsDialog } from '@/features/employees/components/EmployeeLogDetailsDialog';

export const Route = createFileRoute('/_authenticated/employees/logs')({
  component: EmployeeLogsPage,
});

function EmployeeLogsPage() {
  const navigate = useNavigate();
  const routerState = useRouterState();
  const fromState = routerState.location.state as
    | { from?: string; fromLabel?: string }
    | undefined;
  const backPath = fromState?.from || '/employees';
  const backLabel = fromState?.fromLabel || 'Prestadores';
  const [selectedLog, setSelectedLog] = useState<EmployeeAuditLog | null>(null);
  const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);
  
  const { data: logs = [], isLoading } = useQuery({
    queryKey: ['employee-logs'],
    queryFn: employeesService.getEmployeeLogs,
  });

  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="text-sm text-muted-foreground">
            {backLabel} / Logs
          </div>
        <h1 className="text-3xl font-bold">Logs de Prestadores</h1>
        <p className="text-muted-foreground">
          Histórico de alterações em prestadores.
        </p>
        </div>
        <Button variant="outline" size="icon" onClick={() => navigate({ to: backPath })}>
          <ArrowLeft className="h-4 w-4" />
        </Button>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Registros</CardTitle>
        </CardHeader>
        <CardContent>
          {isLoading ? (
            <div className="text-muted-foreground">Carregando logs...</div>
          ) : (
            <EmployeeLogsTable
              logs={logs}
              onOpenEmployee={(id) => navigate({ to: `/employees/${id}` })}
              onViewDetails={(log) => {
                setSelectedLog(log);
                setDetailsDialogOpen(true);
              }}
            />
          )}
        </CardContent>
      </Card>

      <EmployeeLogDetailsDialog
        open={detailsDialogOpen}
        onOpenChange={setDetailsDialogOpen}
        log={selectedLog}
      />
    </div>
  );
}
